import { AuthContext } from "@/context/authContext"
import { useContext } from "react"
import { Navigate, Outlet } from "react-router-dom"

export default function AuthLayout() {

  const { currentUser } = useContext(AuthContext)
  return (
    <div>
      {currentUser ? <Navigate to='/' /> : <Outlet/>}
    </div>
  )
}
